<template>
  <div>
    <div class="tab_bar_box border_box flex_v_center">
      <div class="left_box" @click="gotoSetTree">
        <i class="back_icon"></i>
      </div>
      <div class="right_box_sets" @click.stop="saveSubjectInfo">
        保存 
      </div>
    </div> 
    <div class="padding88" :class="isIOS?'marginbotm2':'marginbotm'">
      <div class="set-tree-info">
        勾选后微信端将接收对应专题预警信息，APP端、PC端弹框预警接收内容需单独设置
      </div>
      <div v-if="localSubjectTree && localSubjectTree.length">
        <div class="tree-title" v-if="specialSubjectTree">
          本地监测
        </div>
        <div class="tree-title" v-else>
          专题监测
        </div>
        <SubjectTree
        :tree="localSubjectTree"
        treeName='本地监测'
        :default-expanded-keys="defaultExpanded"
        :default-checked-keys="defaultCheckedKeys"
        @node-expand="nodeExpand"
        @check="nodeCheck"
        ></SubjectTree>
      </div>  
      <div v-if="specialSubjectTree">
        <div class="tree-title">
          专项监测
        </div>
        <SubjectTree
        :tree="specialSubjectTree"
        treeName='专项监测'
        :default-expanded-keys="defaultExpanded"
        :default-checked-keys="defaultCheckedKeys"
        @node-expand="nodeExpand"
        @check="nodeCheck"
        ></SubjectTree>
      </div>
    </div>
    
  </div>
</template>

<script>
import { Notify } from 'vant';
import { getTreeDatas,saveSubject } from '@/api/wechat.js'
import SubjectTree from '@/components/subjectTree/subjectTree'
export default {
  name:'setTree',
  components:{
    SubjectTree
  },
  data(){
    return {
      defaultExpanded:[1,2], //展开
      defaultCheckedKeys:[], //选中
      isIOS:false,
      checkedSubjectId:[],
      checkedClassId:[],
      localSubjectTree: [],
      specialSubjectTree: [],
    }
  },
  mounted(){
    let userAgent = navigator.userAgent || '';
    this.isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    //查询数据
    this.getTreeData()
  },
  methods:{
    async saveSubjectInfo(){ 
      this.checkedSubjectId = []
      this.getSunbjectId(this.localSubjectTree)
      this.specialSubjectTree.length && this.getSunbjectId(this.specialSubjectTree) 
      let p = {
        data:this.checkedSubjectId
      } 
      let res = await saveSubject(p)
      let {code,data} = res.data
      if(code === 200){
        Notify({
          message: '设置成功',
          duration: 1000,
          color: "",
          className: "notifyNew",
          background: ''
        });
      }
      console.log(data)
    }, 
    // 设置高亮
    getSunbjectId(tree,classid = '') {
      for (const i in tree) { 
        const t = tree[i]
        if(t.checked){
          t.nodeType==1 && this.checkedSubjectId.push({
            subjectId:t.nodeId, // 专题id
            catalogId:classid, // 分类id
          }) 
        }
        if (t.children && t.children.length) {
          this.getSunbjectId(t.children,t.nodeId)
        }
      }
    },
    //查询专题树
    async getTreeData(){ 
      let res = await getTreeDatas() 
      if(res.status === 200){ 
        let {data,code}  = res.data
        if(code === 200){ 
          this.localSubjectTree = this.addTreeKey(data.localSubjectTree,'checked',true)
          this.specialSubjectTree = data.specialSubjectTree ? this.addTreeKey(data.specialSubjectTree,'checked',true)  : false
        } 
      }  
    },
    addTreeKey(treeData, key, val, children = 'children'){
      treeData.forEach(t => {
        t[key] = t.warningReceived || false
        // if(t.nodeId === "8598cce061c3486d9c18857350a81945") t.wechatRecSubjectHidden = 1
        if (t[children] && t[children].length) {
          let wechatRecSubjectHidden = 0
          let warningReceivedSun = 0
          t[children].forEach(c=>{
            if(c.wechatRecSubjectHidden){
              wechatRecSubjectHidden++
            }
            if(c.warningReceived){
              warningReceivedSun++
            }
          })
          if(t[children].length == wechatRecSubjectHidden){
            t.wechatRecSubjectHidden = 1
          }   
          if(t[children].length == warningReceivedSun){
            t['checked'] = true
          }          
          this.addTreeKey(t.children, key, val)
        }
      })
      return treeData
    },
    //展开
    nodeExpand(item){ 
      if(this.defaultExpanded.includes(item.nodeId)){ 
        this.defaultExpanded.splice(this.defaultExpanded.indexOf(item.nodeId),1)
      }else{ 
        this.defaultExpanded.push(item.nodeId)
      }
    },
    setChildrenChecked(item,checkd){
      if(item.children && item.children.length){
        item.children.forEach((item1) => {
          if(!item1.wechatRecSubjectHidden) item1.checked = checkd;
        }); 
      }
      
    },
    //选中
    nodeCheck(item,treeName){    
      if(item.checked){
        //选中
        !this.defaultExpanded.includes(item.nodeId) &&  this.defaultExpanded.push(item.nodeId)
        if(item.children && item.children.length) this.setChildrenChecked(item,true) 
      }else{
        //没有选中
        if(item.children && item.children.length) this.setChildrenChecked(item,false) 
      } 
      let treeData = (treeName === '专项监测') ? this.specialSubjectTree : this.localSubjectTree
      this.setNodeChecked(treeData) 
    },
    setNodeChecked(treeData){
      let result;
      treeData.forEach((item) => {
        if (item.children && item.children.length) {
          item.children.every((item1) => {
            if (!item1.checked) {
              result = false;
              return false;
            }
            result = true;
            return true;
          });
          item.checked = result 
        } 
      });
    },
    gotoSetTree(){
      // this.$router.push('/pushSet')
      this.$parent.subjectSets = false
    }
  }
}
</script>

<style scoped>
	@import url("./setTree.css");
</style>